import { render, staticRenderFns } from "./OrderFormUpload.vue?vue&type=template&id=150c4e35"
import script from "./OrderFormUpload.vue?vue&type=script&lang=js"
export * from "./OrderFormUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports